/* tslint:disable */

declare var Object: any;
export interface JobApplicationInterface {
  "sfdcId"?: string;
  "Applied_Date_on_Taleo__c"?: Date;
  "Create_Service_Contract__c"?: boolean;
  "CreatedById"?: string;
  "CreatedBy__c"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "Driving_Distance_From_Jobsite__c"?: number;
  "Driving_Time__c"?: string;
  "GEO_Code__c"?: string;
  "Hiring_Manager__c"?: string;
  "IsDeleted"?: boolean;
  "Jobsite__c"?: string;
  "LastActivityDate"?: Date;
  "LastModifiedById"?: string;
  "LastModifiedBy__c"?: string;
  "LastModifiedDate"?: Date;
  "LastReferencedDate"?: Date;
  "LastViewedDate"?: Date;
  "Name"?: string;
  "Overall_Health_for_Service_Contract__c"?: boolean;
  "Placement_Reference__c"?: string;
  "Primary_Recruiter__c"?: string;
  "Product__c"?: string;
  "Project_Name__c"?: string;
  "RecordTypeId"?: string;
  "Secondary_Recruiter__c"?: string;
  "Sent_Email__c"?: boolean;
  "Service_Contract_Created__c"?: boolean;
  "Talent_Type__c"?: string;
  "Taleo_Job_Id_Ref__c"?: string;
  "ts2__AccountContact__c"?: string;
  "ts2__Account__c"?: string;
  "ts2__Address__c"?: string;
  "ts2__Agency__c"?: string;
  "ts2__App_Status__c"?: string;
  "ts2__App_Tags__c"?: string;
  "ts2__Application_Source__c"?: string;
  "ts2__Application_Status__c"?: string;
  "ts2__Apply_Agency__c"?: boolean;
  "ts2__Apply_Exception__c"?: boolean;
  "ts2__Candidate_Contact__c"?: string;
  "ts2__Candidate_Source__c"?: string;
  "ts2__Client__c"?: string;
  "ts2__Code__c"?: string;
  "ts2__Completed__c"?: boolean;
  "ts2__Contact_Email__c"?: string;
  "ts2__Contact_Phone__c"?: string;
  "ts2__Contact__c"?: string;
  "ts2__Cover_Letter__c"?: string;
  "ts2__Custom_Email_Message__c"?: string;
  "ts2__Date_Available__c"?: Date;
  "ts2__Disposition_Value__c"?: string;
  "ts2__EEO_Disabled_Received__c"?: string;
  "ts2__EEO_Disabled__c"?: string;
  "ts2__EEO_Gender_Received__c"?: string;
  "ts2__EEO_Gender__c"?: string;
  "ts2__EEO_Race_Received__c"?: string;
  "ts2__EEO_Veteran_Status_Received__c"?: string;
  "ts2__Email__c"?: string;
  "ts2__Exception_Reason_Other__c"?: string;
  "ts2__Exception_Reason__c"?: string;
  "ts2__Experience_Sum__c"?: string;
  "ts2__HiringManager__c"?: string;
  "ts2__Internally_Applied__c"?: boolean;
  "ts2__Invite_to_Apply__c"?: boolean;
  "ts2__Job_Board__c"?: string;
  "ts2__Job_Status__c"?: string;
  "ts2__Job__c"?: string;
  "ts2__Legacy_ApplicationID__c"?: string;
  "ts2__Mobile__c"?: string;
  "ts2__Overall_Reject_Detail__c"?: string;
  "ts2__Overall_Reject_Reason__c"?: string;
  "ts2__Phone__c"?: string;
  "ts2__Prescreen_Score__c"?: number;
  "ts2__PrimaryRecruiter__c"?: string;
  "ts2__Project__c"?: string;
  "ts2__Race__c"?: string;
  "ts2__Rank__c"?: string;
  "ts2__Reject_Detail__c"?: string;
  "ts2__Reject_Reason__c"?: string;
  "ts2__Request_EEO__c"?: boolean;
  "ts2__Revert_Status__c"?: string;
  "ts2__Rollover_Job_Order__c"?: string;
  "ts2__Rollover__c"?: boolean;
  "ts2__Score__c"?: number;
  "ts2__SecondaryRecruiter__c"?: string;
  "ts2__Stage__c"?: string;
  "ts2__Status__c"?: string;
  "ts2__Tracking_Source__c"?: string;
  "ts2__Veteran_Status__c"?: string;
  "ts2__referral_id__c"?: string;
  "ts2__referred_by__c"?: string;
  "ts2extams__Action_Buttons__c"?: string;
  "ts2extams__Application_Matched__c"?: boolean;
  "ts2extams__Communication_Buttons__c"?: string;
  "ts2extams__Control_Buttons__c"?: string;
  "ts2extams__Go_To_Current_Stage__c"?: string;
  "ts2extams__Overall_SubStatus_API_Name__c"?: string;
  "ts2extams__Overall_SubStatus_Id__c"?: string;
  "ts2extams__Overall_SubStatus_Link__c"?: string;
  "ts2extams__Resume_Uploaded__c"?: string;
  "ts2extams__Substatus__c"?: string;
  "ts2extams__Translated_Substatus__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class JobApplication implements JobApplicationInterface {
  "sfdcId": string;
  "Applied_Date_on_Taleo__c": Date;
  "Create_Service_Contract__c": boolean;
  "CreatedById": string;
  "CreatedBy__c": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "Driving_Distance_From_Jobsite__c": number;
  "Driving_Time__c": string;
  "GEO_Code__c": string;
  "Hiring_Manager__c": string;
  "IsDeleted": boolean;
  "Jobsite__c": string;
  "LastActivityDate": Date;
  "LastModifiedById": string;
  "LastModifiedBy__c": string;
  "LastModifiedDate": Date;
  "LastReferencedDate": Date;
  "LastViewedDate": Date;
  "Name": string;
  "Overall_Health_for_Service_Contract__c": boolean;
  "Placement_Reference__c": string;
  "Primary_Recruiter__c": string;
  "Product__c": string;
  "Project_Name__c": string;
  "RecordTypeId": string;
  "Secondary_Recruiter__c": string;
  "Sent_Email__c": boolean;
  "Service_Contract_Created__c": boolean;
  "Talent_Type__c": string;
  "Taleo_Job_Id_Ref__c": string;
  "ts2__AccountContact__c": string;
  "ts2__Account__c": string;
  "ts2__Address__c": string;
  "ts2__Agency__c": string;
  "ts2__App_Status__c": string;
  "ts2__App_Tags__c": string;
  "ts2__Application_Source__c": string;
  "ts2__Application_Status__c": string;
  "ts2__Apply_Agency__c": boolean;
  "ts2__Apply_Exception__c": boolean;
  "ts2__Candidate_Contact__c": string;
  "ts2__Candidate_Source__c": string;
  "ts2__Client__c": string;
  "ts2__Code__c": string;
  "ts2__Completed__c": boolean;
  "ts2__Contact_Email__c": string;
  "ts2__Contact_Phone__c": string;
  "ts2__Contact__c": string;
  "ts2__Cover_Letter__c": string;
  "ts2__Custom_Email_Message__c": string;
  "ts2__Date_Available__c": Date;
  "ts2__Disposition_Value__c": string;
  "ts2__EEO_Disabled_Received__c": string;
  "ts2__EEO_Disabled__c": string;
  "ts2__EEO_Gender_Received__c": string;
  "ts2__EEO_Gender__c": string;
  "ts2__EEO_Race_Received__c": string;
  "ts2__EEO_Veteran_Status_Received__c": string;
  "ts2__Email__c": string;
  "ts2__Exception_Reason_Other__c": string;
  "ts2__Exception_Reason__c": string;
  "ts2__Experience_Sum__c": string;
  "ts2__HiringManager__c": string;
  "ts2__Internally_Applied__c": boolean;
  "ts2__Invite_to_Apply__c": boolean;
  "ts2__Job_Board__c": string;
  "ts2__Job_Status__c": string;
  "ts2__Job__c": string;
  "ts2__Legacy_ApplicationID__c": string;
  "ts2__Mobile__c": string;
  "ts2__Overall_Reject_Detail__c": string;
  "ts2__Overall_Reject_Reason__c": string;
  "ts2__Phone__c": string;
  "ts2__Prescreen_Score__c": number;
  "ts2__PrimaryRecruiter__c": string;
  "ts2__Project__c": string;
  "ts2__Race__c": string;
  "ts2__Rank__c": string;
  "ts2__Reject_Detail__c": string;
  "ts2__Reject_Reason__c": string;
  "ts2__Request_EEO__c": boolean;
  "ts2__Revert_Status__c": string;
  "ts2__Rollover_Job_Order__c": string;
  "ts2__Rollover__c": boolean;
  "ts2__Score__c": number;
  "ts2__SecondaryRecruiter__c": string;
  "ts2__Stage__c": string;
  "ts2__Status__c": string;
  "ts2__Tracking_Source__c": string;
  "ts2__Veteran_Status__c": string;
  "ts2__referral_id__c": string;
  "ts2__referred_by__c": string;
  "ts2extams__Action_Buttons__c": string;
  "ts2extams__Application_Matched__c": boolean;
  "ts2extams__Communication_Buttons__c": string;
  "ts2extams__Control_Buttons__c": string;
  "ts2extams__Go_To_Current_Stage__c": string;
  "ts2extams__Overall_SubStatus_API_Name__c": string;
  "ts2extams__Overall_SubStatus_Id__c": string;
  "ts2extams__Overall_SubStatus_Link__c": string;
  "ts2extams__Resume_Uploaded__c": string;
  "ts2extams__Substatus__c": string;
  "ts2extams__Translated_Substatus__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: JobApplicationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `JobApplication`.
   */
  public static getModelName() {
    return "JobApplication";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of JobApplication for dynamic purposes.
  **/
  public static factory(data: JobApplicationInterface): JobApplication{
    return new JobApplication(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'JobApplication',
      plural: 'JobApplications',
      path: 'JobApplications',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Applied_Date_on_Taleo__c": {
          name: 'Applied_Date_on_Taleo__c',
          type: 'Date'
        },
        "Create_Service_Contract__c": {
          name: 'Create_Service_Contract__c',
          type: 'boolean'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedBy__c": {
          name: 'CreatedBy__c',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "Driving_Distance_From_Jobsite__c": {
          name: 'Driving_Distance_From_Jobsite__c',
          type: 'number'
        },
        "Driving_Time__c": {
          name: 'Driving_Time__c',
          type: 'string'
        },
        "GEO_Code__c": {
          name: 'GEO_Code__c',
          type: 'string'
        },
        "Hiring_Manager__c": {
          name: 'Hiring_Manager__c',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "Jobsite__c": {
          name: 'Jobsite__c',
          type: 'string'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastModifiedBy__c": {
          name: 'LastModifiedBy__c',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "Overall_Health_for_Service_Contract__c": {
          name: 'Overall_Health_for_Service_Contract__c',
          type: 'boolean'
        },
        "Placement_Reference__c": {
          name: 'Placement_Reference__c',
          type: 'string'
        },
        "Primary_Recruiter__c": {
          name: 'Primary_Recruiter__c',
          type: 'string'
        },
        "Product__c": {
          name: 'Product__c',
          type: 'string'
        },
        "Project_Name__c": {
          name: 'Project_Name__c',
          type: 'string'
        },
        "RecordTypeId": {
          name: 'RecordTypeId',
          type: 'string'
        },
        "Secondary_Recruiter__c": {
          name: 'Secondary_Recruiter__c',
          type: 'string'
        },
        "Sent_Email__c": {
          name: 'Sent_Email__c',
          type: 'boolean'
        },
        "Service_Contract_Created__c": {
          name: 'Service_Contract_Created__c',
          type: 'boolean'
        },
        "Talent_Type__c": {
          name: 'Talent_Type__c',
          type: 'string'
        },
        "Taleo_Job_Id_Ref__c": {
          name: 'Taleo_Job_Id_Ref__c',
          type: 'string'
        },
        "ts2__AccountContact__c": {
          name: 'ts2__AccountContact__c',
          type: 'string'
        },
        "ts2__Account__c": {
          name: 'ts2__Account__c',
          type: 'string'
        },
        "ts2__Address__c": {
          name: 'ts2__Address__c',
          type: 'string'
        },
        "ts2__Agency__c": {
          name: 'ts2__Agency__c',
          type: 'string'
        },
        "ts2__App_Status__c": {
          name: 'ts2__App_Status__c',
          type: 'string'
        },
        "ts2__App_Tags__c": {
          name: 'ts2__App_Tags__c',
          type: 'string'
        },
        "ts2__Application_Source__c": {
          name: 'ts2__Application_Source__c',
          type: 'string'
        },
        "ts2__Application_Status__c": {
          name: 'ts2__Application_Status__c',
          type: 'string'
        },
        "ts2__Apply_Agency__c": {
          name: 'ts2__Apply_Agency__c',
          type: 'boolean'
        },
        "ts2__Apply_Exception__c": {
          name: 'ts2__Apply_Exception__c',
          type: 'boolean'
        },
        "ts2__Candidate_Contact__c": {
          name: 'ts2__Candidate_Contact__c',
          type: 'string'
        },
        "ts2__Candidate_Source__c": {
          name: 'ts2__Candidate_Source__c',
          type: 'string'
        },
        "ts2__Client__c": {
          name: 'ts2__Client__c',
          type: 'string'
        },
        "ts2__Code__c": {
          name: 'ts2__Code__c',
          type: 'string'
        },
        "ts2__Completed__c": {
          name: 'ts2__Completed__c',
          type: 'boolean'
        },
        "ts2__Contact_Email__c": {
          name: 'ts2__Contact_Email__c',
          type: 'string'
        },
        "ts2__Contact_Phone__c": {
          name: 'ts2__Contact_Phone__c',
          type: 'string'
        },
        "ts2__Contact__c": {
          name: 'ts2__Contact__c',
          type: 'string'
        },
        "ts2__Cover_Letter__c": {
          name: 'ts2__Cover_Letter__c',
          type: 'string'
        },
        "ts2__Custom_Email_Message__c": {
          name: 'ts2__Custom_Email_Message__c',
          type: 'string'
        },
        "ts2__Date_Available__c": {
          name: 'ts2__Date_Available__c',
          type: 'Date'
        },
        "ts2__Disposition_Value__c": {
          name: 'ts2__Disposition_Value__c',
          type: 'string'
        },
        "ts2__EEO_Disabled_Received__c": {
          name: 'ts2__EEO_Disabled_Received__c',
          type: 'string'
        },
        "ts2__EEO_Disabled__c": {
          name: 'ts2__EEO_Disabled__c',
          type: 'string'
        },
        "ts2__EEO_Gender_Received__c": {
          name: 'ts2__EEO_Gender_Received__c',
          type: 'string'
        },
        "ts2__EEO_Gender__c": {
          name: 'ts2__EEO_Gender__c',
          type: 'string'
        },
        "ts2__EEO_Race_Received__c": {
          name: 'ts2__EEO_Race_Received__c',
          type: 'string'
        },
        "ts2__EEO_Veteran_Status_Received__c": {
          name: 'ts2__EEO_Veteran_Status_Received__c',
          type: 'string'
        },
        "ts2__Email__c": {
          name: 'ts2__Email__c',
          type: 'string'
        },
        "ts2__Exception_Reason_Other__c": {
          name: 'ts2__Exception_Reason_Other__c',
          type: 'string'
        },
        "ts2__Exception_Reason__c": {
          name: 'ts2__Exception_Reason__c',
          type: 'string'
        },
        "ts2__Experience_Sum__c": {
          name: 'ts2__Experience_Sum__c',
          type: 'string'
        },
        "ts2__HiringManager__c": {
          name: 'ts2__HiringManager__c',
          type: 'string'
        },
        "ts2__Internally_Applied__c": {
          name: 'ts2__Internally_Applied__c',
          type: 'boolean'
        },
        "ts2__Invite_to_Apply__c": {
          name: 'ts2__Invite_to_Apply__c',
          type: 'boolean'
        },
        "ts2__Job_Board__c": {
          name: 'ts2__Job_Board__c',
          type: 'string'
        },
        "ts2__Job_Status__c": {
          name: 'ts2__Job_Status__c',
          type: 'string'
        },
        "ts2__Job__c": {
          name: 'ts2__Job__c',
          type: 'string'
        },
        "ts2__Legacy_ApplicationID__c": {
          name: 'ts2__Legacy_ApplicationID__c',
          type: 'string'
        },
        "ts2__Mobile__c": {
          name: 'ts2__Mobile__c',
          type: 'string'
        },
        "ts2__Overall_Reject_Detail__c": {
          name: 'ts2__Overall_Reject_Detail__c',
          type: 'string'
        },
        "ts2__Overall_Reject_Reason__c": {
          name: 'ts2__Overall_Reject_Reason__c',
          type: 'string'
        },
        "ts2__Phone__c": {
          name: 'ts2__Phone__c',
          type: 'string'
        },
        "ts2__Prescreen_Score__c": {
          name: 'ts2__Prescreen_Score__c',
          type: 'number'
        },
        "ts2__PrimaryRecruiter__c": {
          name: 'ts2__PrimaryRecruiter__c',
          type: 'string'
        },
        "ts2__Project__c": {
          name: 'ts2__Project__c',
          type: 'string'
        },
        "ts2__Race__c": {
          name: 'ts2__Race__c',
          type: 'string'
        },
        "ts2__Rank__c": {
          name: 'ts2__Rank__c',
          type: 'string'
        },
        "ts2__Reject_Detail__c": {
          name: 'ts2__Reject_Detail__c',
          type: 'string'
        },
        "ts2__Reject_Reason__c": {
          name: 'ts2__Reject_Reason__c',
          type: 'string'
        },
        "ts2__Request_EEO__c": {
          name: 'ts2__Request_EEO__c',
          type: 'boolean'
        },
        "ts2__Revert_Status__c": {
          name: 'ts2__Revert_Status__c',
          type: 'string'
        },
        "ts2__Rollover_Job_Order__c": {
          name: 'ts2__Rollover_Job_Order__c',
          type: 'string'
        },
        "ts2__Rollover__c": {
          name: 'ts2__Rollover__c',
          type: 'boolean'
        },
        "ts2__Score__c": {
          name: 'ts2__Score__c',
          type: 'number'
        },
        "ts2__SecondaryRecruiter__c": {
          name: 'ts2__SecondaryRecruiter__c',
          type: 'string'
        },
        "ts2__Stage__c": {
          name: 'ts2__Stage__c',
          type: 'string'
        },
        "ts2__Status__c": {
          name: 'ts2__Status__c',
          type: 'string'
        },
        "ts2__Tracking_Source__c": {
          name: 'ts2__Tracking_Source__c',
          type: 'string'
        },
        "ts2__Veteran_Status__c": {
          name: 'ts2__Veteran_Status__c',
          type: 'string'
        },
        "ts2__referral_id__c": {
          name: 'ts2__referral_id__c',
          type: 'string'
        },
        "ts2__referred_by__c": {
          name: 'ts2__referred_by__c',
          type: 'string'
        },
        "ts2extams__Action_Buttons__c": {
          name: 'ts2extams__Action_Buttons__c',
          type: 'string'
        },
        "ts2extams__Application_Matched__c": {
          name: 'ts2extams__Application_Matched__c',
          type: 'boolean'
        },
        "ts2extams__Communication_Buttons__c": {
          name: 'ts2extams__Communication_Buttons__c',
          type: 'string'
        },
        "ts2extams__Control_Buttons__c": {
          name: 'ts2extams__Control_Buttons__c',
          type: 'string'
        },
        "ts2extams__Go_To_Current_Stage__c": {
          name: 'ts2extams__Go_To_Current_Stage__c',
          type: 'string'
        },
        "ts2extams__Overall_SubStatus_API_Name__c": {
          name: 'ts2extams__Overall_SubStatus_API_Name__c',
          type: 'string'
        },
        "ts2extams__Overall_SubStatus_Id__c": {
          name: 'ts2extams__Overall_SubStatus_Id__c',
          type: 'string'
        },
        "ts2extams__Overall_SubStatus_Link__c": {
          name: 'ts2extams__Overall_SubStatus_Link__c',
          type: 'string'
        },
        "ts2extams__Resume_Uploaded__c": {
          name: 'ts2extams__Resume_Uploaded__c',
          type: 'string'
        },
        "ts2extams__Substatus__c": {
          name: 'ts2extams__Substatus__c',
          type: 'string'
        },
        "ts2extams__Translated_Substatus__c": {
          name: 'ts2extams__Translated_Substatus__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
